const PROVINCE_NAMES = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland & Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Quebec',
  SK: 'Saskatchewan',
  YT: 'Yukon',
};

/** Full province name for an agent's two-letter code; falls back to the raw
 * value (or empty string) rather than guessing a province when unset. */
export function provinceLabel(province) {
  const code = String(province || '').trim().toUpperCase();
  if (!code) return '';
  return PROVINCE_NAMES[code] || province;
}
